import { motion } from "framer-motion";

export const Chapter = ({ number, title, overline }) => (
  <div className="relative mb-16 md:mb-24">
    <span className="absolute -top-10 md:-top-20 left-0 font-heading font-extrabold text-[7rem] md:text-[13rem] leading-none text-outline-dim select-none pointer-events-none">
      {number}
    </span>
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="relative pt-10 md:pt-16"
    >
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-volt mb-4">{overline}</p>
      <h2 className="font-heading font-extrabold tracking-tighter text-3xl md:text-5xl text-paper">{title}</h2>
    </motion.div>
  </div>
);
